import React from 'react';
import styled from 'styled-components';

const DocsPage = styled.div`
  max-width: 800px;
  margin: 0 auto;
  
  h1 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 2.5rem;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 1rem;
    line-height: 1.2;
  }
  
  h2 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.8rem;
    font-weight: 600;
    color: #ffffff;
    margin: 2rem 0 1rem 0;
    line-height: 1.3;
  }
  
  h3 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.4rem;
    font-weight: 600;
    color: #ffffff;
    margin: 1.5rem 0 0.75rem 0;
    line-height: 1.4;
  }
  
  p {
    font-family: 'Roboto', sans-serif;
    font-size: 1rem;
    line-height: 1.6;
    color: #e5e7eb;
    margin-bottom: 1rem;
  }
  
  ul, ol {
    margin: 1rem 0;
    padding-left: 1.5rem;
  }
  
  li {
    font-family: 'Roboto', sans-serif;
    font-size: 1rem;
    line-height: 1.6;
    color: #e5e7eb;
    margin-bottom: 0.5rem;
  }
  
  .contract-grid {
    display: grid;
    gap: 1.5rem;
    margin: 2rem 0;
  }
  
  .contract-card {
    background: rgba(168, 85, 247, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
  }
  
  .contract-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .contract-address {
    font-family: 'monospace', sans-serif;
    font-size: 0.9rem;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.3);
    padding: 0.75rem;
    border-radius: 8px;
    margin: 0.75rem 0;
    word-break: break-all;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }
  
  .copy-button {
    background: rgba(168, 85, 247, 0.2);
    color: #ffffff;
    padding: 0.25rem 0.75rem;
    border-radius: 4px;
    font-size: 0.8rem;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    
    &:hover {
      background: rgba(168, 85, 247, 0.3);
    }
  }
  
  .explorer-link {
    color: #60a5fa;
    text-decoration: none;
    font-size: 0.9rem;
    font-weight: 500;
    transition: color 0.2s ease;
    
    &:hover {
      color: #93c5fd;
      text-decoration: underline;
    }
  }
  
  .contract-description {
    font-family: 'Inter', sans-serif;
    color: #d1d5db;
    font-size: 0.95rem;
    line-height: 1.5;
    margin-top: 0.75rem;
  }
  
  .contract-details {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 1rem;
    margin-top: 1rem;
  }
  
  .detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;
  }
  
  .detail-row:last-child {
  }
  
  .detail-label {
    font-family: 'Inter', sans-serif;
    color: #9ca3af;
    font-size: 0.9rem;
  }
  
  .detail-value {
    font-family: 'Inter', sans-serif;
    color: #ffffff;
    font-weight: 500;
    font-size: 0.9rem;
  }
  
  .network-info {
    background: rgba(59, 130, 246, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 2rem 0;
  }
  
  .network-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    margin-top: 1rem;
  }
  
  .network-item {
    text-align: center;
  }
  
  .network-label {
    font-family: 'Inter', sans-serif;
    font-size: 0.875rem;
    color: #9ca3af;
    margin-bottom: 0.25rem;
  }
  
  .network-value {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    color: #ffffff;
    font-size: 1rem;
  }
  
  .fee-distribution {
    background: rgba(16, 185, 129, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 2rem 0;
  }
  
  .fee-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #10b981;
    margin-bottom: 1rem;
  }
  
  .fee-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
    margin-top: 1rem;
  }
  
  .fee-item {
    background: rgba(16, 185, 129, 0.05);
    border-radius: 8px;
    padding: 1rem;
    text-align: center;
  }
  
  .fee-percentage {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #10b981;
    margin-bottom: 0.5rem;
  }
  
  .fee-wallet {
    font-family: 'monospace', sans-serif;
    font-size: 0.8rem;
    color: #d1d5db;
    word-break: break-all;
  }
  
  .verification-note {
    background: rgba(245, 158, 11, 0.1);
    border-radius: 8px;
    padding: 1rem;
    margin: 2rem 0;
  }
  
  .verification-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    color: #f59e0b;
    margin-bottom: 0.5rem;
  }
  
  .verification-text {
    font-family: 'Inter', sans-serif;
    color: #d1d5db;
    font-size: 0.95rem;
  }
  
  .security-note {
    background: rgba(16, 185, 129, 0.1);
    border-radius: 8px;
    padding: 1rem;
    margin: 2rem 0;
  }
  
  .security-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    color: #10b981;
    margin-bottom: 0.5rem;
  }
  
  .security-text {
    font-family: 'Inter', sans-serif;
    color: #d1d5db;
    font-size: 0.95rem;
  }
  
  .integration-section {
    background: rgba(59, 130, 246, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 2rem 0;
  }
  
  .integration-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #3b82f6;
    margin-bottom: 1rem;
  }
  
  .integration-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1rem;
    margin-top: 1rem;
  }
  
  .integration-item {
    background: rgba(59, 130, 246, 0.05);
    border-radius: 8px;
    padding: 1rem;
  }
  
  .integration-name {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 0.5rem;
  }
  
  .integration-description {
    font-family: 'Inter', sans-serif;
    color: #d1d5db;
    font-size: 0.9rem;
    line-height: 1.4;
  }
  
  .code-block {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    padding: 1rem;
    margin: 1rem 0;
    font-family: 'monospace', sans-serif;
    font-size: 0.9rem;
    color: #e5e7eb;
    overflow-x: auto;
  }
  
  @media (max-width: 768px) {
    h1 {
      font-size: 2rem;
    }
    
    h2 {
      font-size: 1.5rem;
    }
    
    .contract-address {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }
    
    .network-grid {
      grid-template-columns: 1fr;
    }
    
    .fee-grid {
      grid-template-columns: 1fr;
    }
    
    .integration-grid {
      grid-template-columns: 1fr;
    }
  }
`;

const ContractAddresses: React.FC = () => {
  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const contracts = [
    {
      name: 'MavrkTokenFactory',
      address: '0xD827F74E292060D4B495b7b82d6f2470C59ce89d',
      description: 'The main factory contract that handles token deployment with gasless and self-funded options. Deploys ERC-2771 compatible tokens with automatic liquidity creation.',
      explorer: 'https://explorer.inkonchain.com/address/0xD827F74E292060D4B495b7b82d6f2470C59ce89d',
      details: {
        'Contract Type': 'Factory Contract',
        'Solidity Version': '0.8.20',
        'License': 'MIT',
        'Functions': 'deployToken, getTokenCount, getTokenAddress',
        'Events': 'TokenDeployed, LiquidityCreated',
        'Features': 'Gasless deployment, ERC-2771 support',
        'Admin': 'Mavrk Team'
      }
    },
    {
      name: 'MavrkLocker',
      address: '0x0f417FaB5b78aaCC265137Ebd83b41c44f515d3F',
      description: 'Handles LP token locking and fee distribution. All liquidity position NFTs from token deployments are automatically locked in this contract for security.',
      explorer: 'https://explorer.inkonchain.com/address/0x0f417FaB5b78aaCC265137Ebd83b41c44f515d3F',
      details: {
        'Contract Type': 'Locker Contract',
        'Solidity Version': '0.8.20',
        'License': 'MIT',
        'Functions': 'lockLPToken, collectFees, distributeFees',
        'Events': 'LPTokenLocked, FeesCollected, FeesDistributed',
        'Admin': 'Mavrk Team'
      }
    },
    {
      name: 'MavrkTokenLocker',
      address: '0xd2C5947A6777500D9b7ad55a4D48AeF855AE6aBA',
      description: 'Advanced token time-lock contract that allows users to lock any ERC-20 token for custom durations. Features multiple locks per user, no early withdrawal, and gas-optimized operations.',
      explorer: 'https://explorer.inkonchain.com/address/0xd2C5947A6777500D9b7ad55a4D48AeF855AE6aBA',
      details: {
        'Contract Type': 'Token Locker Contract',
        'Solidity Version': '0.8.20',
        'License': 'MIT',
        'Functions': 'newTokenLock, withdrawTokenLock, getLockInfo',
        'Events': 'TokenLockCreated, TokensWithdrawn',
        'Features': 'Multiple locks, no early withdrawal, gas optimized',
        'Admin': 'Mavrk Team'
      }
    },
    {
      name: 'Position Manager (NPM)',
      address: '0xC0836E5B058BBE22ae2266e1AC488A1A0fD8DCE8',
      description: 'Uniswap V3 Position Manager contract that handles concentrated liquidity positions. This is the standard Uniswap V3 contract for managing LP positions.',
      explorer: 'https://explorer.inkonchain.com/address/0xC0836E5B058BBE22ae2266e1AC488A1A0fD8DCE8',
      details: {
        'Contract Type': 'Uniswap V3 Position Manager',
        'Solidity Version': '0.7.6',
        'License': 'GPL-2.0',
        'Functions': 'mint, burn, collect, increaseLiquidity',
        'Events': 'IncreaseLiquidity, DecreaseLiquidity, Collect',
        'Admin': 'Relay Team'
      }
    },
    {
      name: 'SwapRouter02',
      address: '0x177778F19E89dD1012BdBe603F144088A95C4B53',
      description: 'Uniswap V3 Swap Router contract that handles token swaps and routing. Enables trading with 1% swap fee distribution (25% creator, 75% platform).',
      explorer: 'https://explorer.inkonchain.com/address/0x177778F19E89dD1012BdBe603F144088A95C4B53',
      details: {
        'Contract Type': 'Uniswap V3 Swap Router',
        'Solidity Version': '0.7.6',
        'License': 'GPL-2.0',
        'Functions': 'exactInputSingle, exactInput, exactOutputSingle',
        'Events': 'Swap, Transfer',
        'Fee Structure': '1% total, 25% creator, 75% platform',
        'Admin': 'Uniswap Labs'
      }
    }
  ];

  return (
    <DocsPage>
      <h1>Contract Addresses</h1>
      
      <p>All Mavrk.ink smart contracts are deployed on the Ink Layer 2 network (Chain ID: 57073). This page provides comprehensive information about each contract, including addresses, functions, and integration details. Updated with the new 25% creator earnings structure and advanced token locking capabilities.</p>

      <h2>Main Contracts</h2>
      
      <div className="contract-grid">
        {contracts.map((contract, index) => (
          <div key={index} className="contract-card">
            <h3 className="contract-title">
              {contract.name}
            </h3>
            <div className="contract-address">
              <span>{contract.address}</span>
              <button 
                className="copy-button"
                onClick={() => copyToClipboard(contract.address)}
                title="Copy address"
              >
                Copy
              </button>
            </div>
            <div className="contract-description">
              {contract.description}
            </div>
            <div className="contract-details">
              {Object.entries(contract.details).map(([key, value]) => (
                <div key={key} className="detail-row">
                  <span className="detail-label">{key}</span>
                  <span className="detail-value">{value}</span>
                </div>
              ))}
            </div>
            <a 
              href={contract.explorer} 
              target="_blank" 
              rel="noopener noreferrer"
              className="explorer-link"
            >
              View on Explorer →
            </a>
          </div>
        ))}
      </div>

      <h2>Network Configuration</h2>
      
      <div className="network-info">
        <h3>Ink Layer 2 Network Details</h3>
        <div className="network-grid">
          <div className="network-item">
            <div className="network-label">Chain ID</div>
            <div className="network-value">57073</div>
          </div>
          <div className="network-item">
            <div className="network-label">Network Name</div>
            <div className="network-value">Ink Layer 2</div>
          </div>
          <div className="network-item">
            <div className="network-label">RPC URL</div>
            <div className="network-value">https://rpc.inkonchain.com</div>
          </div>
          <div className="network-item">
            <div className="network-label">Explorer</div>
            <div className="network-value">
              <a href="https://explorer.inkonchain.com" target="_blank" rel="noopener noreferrer" className="explorer-link">
                explorer.inkonchain.com
              </a>
            </div>
          </div>
          <div className="network-item">
            <div className="network-label">Native Token</div>
            <div className="network-value">ETH</div>
          </div>
          <div className="network-item">
            <div className="network-label">WETH Address</div>
            <div className="network-value">
              <span 
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={() => copyToClipboard('0x4200000000000000000000000000000000000006')}
                title="Click to copy full address"
              >
                0x420...0006
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="verification-note">
        <div className="verification-title">Contract Verification</div>
        <div className="verification-text">
          All contracts are verified on the Ink Layer 2 explorer. You can view the source code, interact with the contracts, and verify their functionality directly through the explorer links above. This ensures complete transparency and allows developers to audit the contract code.
        </div>
      </div>

      <h2>Fee Structure</h2>
      
      <div className="fee-distribution">
        <h3 className="fee-title">Trading Fee Distribution</h3>
        <div className="fee-grid">
          <div className="fee-item">
            <div className="fee-percentage">25%</div>
            <div className="fee-label">Creator Earnings</div>
            <div className="fee-wallet">Distributed to token creators automatically</div>
          </div>
          <div className="fee-item">
            <div className="fee-percentage">75%</div>
            <div className="fee-label">Platform Fees</div>
            <div className="fee-wallet">Supports platform development and sustainability</div>
          </div>
        </div>
        <div className="info-box">
          <div className="info-title">Total Trading Fee</div>
          <div className="info-text">1% of all token swaps, automatically distributed via MavrkLocker contract</div>
        </div>
      </div>

      <div className="security-note">
        <div className="security-title">Security & Audits</div>
        <div className="security-text">
          <ul style={{ margin: '0.5rem 0', paddingLeft: '1.5rem' }}>
            <li><strong>Open Source:</strong> All Mavrk contracts are verified and open source on Blockscout</li>
            <li><strong>LP Locking:</strong> All liquidity positions are automatically locked in MavrkTokenLocker</li>
            <li><strong>No Admin Keys:</strong> Contract admins cannot access user funds</li>
            <li><strong>Transparent Fees:</strong> Fee distribution is automated and verifiable on-chain</li>
            <li><strong>Open Source:</strong> Contract source code is publicly available</li>
            <li><strong>Non-Custodial:</strong> Users maintain full control of their tokens</li>
            <li><strong>Token Locker Security:</strong> Reentrancy protection and safe token transfers</li>
          </ul>
        </div>
      </div>
    </DocsPage>
  );
};

export default ContractAddresses;